import { render } from "./VisualizarEntrevista.vue?vue&type=template&id=0561b468&scoped=true"
import script from "./VisualizarEntrevista.vue?vue&type=script&lang=js"
export * from "./VisualizarEntrevista.vue?vue&type=script&lang=js"

import "./VisualizarEntrevista.vue?vue&type=style&index=0&id=0561b468&lang=css"
import "./VisualizarEntrevista.vue?vue&type=style&index=1&id=0561b468&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0561b468"]])

export default __exports__